import {useState, useEffect} from 'react'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import {Col, Dropdown, Row, Spinner} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import Api from '../../../../../thesis-and-dissertations/helpers/api'

import {useNavigate} from 'react-router-dom'
import FormImport from './FormImport'
import SortableHeaders from '../Reviewer/SortableHeaders'
import {timestampsFormat} from 'thesis-and-dissertations/helpers/helper'
const api = new Api()

const heads = [
  {
    name: '',
    label: 'Nama',
  },
  {
    name: '',
    label: 'No Registrasi',
  },
  {
    name: '',
    label: 'Kategori',
  },
  {
    name: '',
    label: 'Status Administrasi',
  },
  {
    name: '',
    label: 'Waktu Administasi',
  },
  {
    name: '',
    label: 'Waktu Proposal',
  },
  {
    name: '',
    label: 'Nilai Proposal',
  },
  {
    name: '',
    label: 'Nilai Wawancara',
  },
  {
    name: '',
    label: 'Kode Verif Admin',
  },
  {
    name: '',
    label: 'Kode Verif Proposal',
  },
  {
    name: '',
    label: 'Kode Verif Wawancara',
  },
]

const PanaRegistrationPeriodPage = () => {
  const navigate = useNavigate()

  const [data, setData] = useState<any>([])
  const [errors, setErrors] = useState<any>({})
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [showModal, setShowModal] = useState<boolean>(false)

  const [query, setQuery] = useState<any>({})

  const [sorting, setSorting] = useState({
    sort_field: '',
    sort_order: '', // 'asc' atau 'desc'
  })

  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })

  const paginator: any = usePagination({
    totalCount: data?.total,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  useEffect(() => {
    fetchMonitoring({...query, ...{per_page: pagination.per_page, page: pagination.page}})
  }, [query, pagination.per_page, pagination.page])

  useEffect(() => {
    setQuery({
      ...query,
      sort_field: sorting.sort_field,
      sort_order: sorting.sort_order,
    })
  }, [sorting])

  const fetchMonitoring = (params = {}) => {
    setIsLoading(true)
    api
      .getMonitoring({...params})
      .then((response: any) => {
        setIsLoading(false)
        const data = response.data
        setData(data.data)
      })
      .catch((error: any) => {
        setIsLoading(false)
        const {data} = error.response
        setErrors(data?.meta?.error)
      })
  }

  const downloadBase64File = (base64Data: string, filename: string) => {
    const link = document.createElement('a')
    link.href = base64Data // langsung pakai data URI
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const fetchTemplate = () => {
    setIsLoading(true)
    api
      .getAssessmentExport()
      .then((response: any) => {
        setIsLoading(false)
        const {data} = response?.data
        downloadBase64File(data?.file, data?.name)
      })
      .catch((error: any) => {
        setIsLoading(false)
        const {data} = error.response
        setErrors(data?.meta?.error)
      })
  }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  const handleShowModal = (action: boolean) => {
    setShowModal(action)
    fetchMonitoring({...query, ...{per_page: pagination.per_page, page: pagination.page}})
  }

  const handleSorting = (sort_field: any) => {
    setSorting((prev) => {
      const isSameKey = prev.sort_field === sort_field
      const newOrder = isSameKey && prev.sort_order === 'asc' ? 'desc' : 'asc'
      return {sort_field, sort_order: newOrder}
    })
  }

  return (
    <>
      <FormImport showModal={showModal} handleShowModal={handleShowModal} />
      <div className='row'>
        <div className='col-md-12'>
          <div className='card-custom'>
            {/* Filter dan Action Buttons */}
            <Row>
              <Col md={8}>
                <Form.Control
                  className='mb-2'
                  placeholder='Cari...'
                  name='q'
                  onChange={(e) => {
                    setPagination({...pagination, per_page: pagination.per_page, page: 1})
                    setQuery({...query, q: e.target.value})
                  }}
                />
              </Col>
              <Col md={2}>
                <Button
                  type='button'
                  className='form-control mb-2'
                  onClick={() => setShowModal(true)}
                >
                  <span className='fa fa-upload' /> Import Excel
                </Button>
              </Col>
              <Col md={2}>
                <Button type='button' className='form-control mb-2' onClick={fetchTemplate}>
                  <span className='fa fa-download' /> Export Excel
                </Button>
              </Col>
            </Row>

            {/* TABEL RESPONSIVE */}
            <div className='mt-4' style={{overflowX: 'auto', width: '100%'}}>
              <div style={{maxWidth: 1000}}>
                <Table className='table-striped align-middle' style={{minWidth: '1200px'}}>
                  <thead>
                    <tr>
                      <th>#</th>
                      <SortableHeaders
                        label='Nama'
                        field='nama'
                        handleSorting={handleSorting}
                        sorting={sorting}
                      />
                      <SortableHeaders
                        label='No Registrasi'
                        field='no_registrasi'
                        handleSorting={handleSorting}
                        sorting={sorting}
                      />
                      <SortableHeaders
                        label='Kategori'
                        field='kategori'
                        handleSorting={handleSorting}
                        sorting={sorting}
                      />
                      <SortableHeaders
                        label='Status Administrasi'
                        field='status_administrasi'
                        handleSorting={handleSorting}
                        sorting={sorting}
                      />
                      <SortableHeaders
                        label='Waktu Administrasi'
                        field='waktu_administrasi'
                        handleSorting={handleSorting}
                        sorting={sorting}
                      />
                      <SortableHeaders
                        label='Waktu Proposal'
                        field='waktu_proposal'
                        handleSorting={handleSorting}
                        sorting={sorting}
                      />
                      <SortableHeaders
                        label='Nilai Proposal'
                        field='rata_rata_proposal'
                        handleSorting={handleSorting}
                        sorting={sorting}
                      />
                      <SortableHeaders
                        label='Nilai Wawancara'
                        field='rata_rata_wawancara'
                        handleSorting={handleSorting}
                        sorting={sorting}
                      />
                      <SortableHeaders
                        label='Penilai Verifikator'
                        field='penilai_verifikator'
                        handleSorting={handleSorting}
                        sorting={sorting}
                      />
                      <SortableHeaders
                        label='Penilai Proposal 1'
                        field='penilai_proposal_1'
                        handleSorting={handleSorting}
                        sorting={sorting}
                      />
                      <SortableHeaders
                        label='Penilai Proposal 2'
                        field='penilai_proposal_2'
                        handleSorting={handleSorting}
                        sorting={sorting}
                      />
                      <SortableHeaders
                        label='Penilai Wawancara 1'
                        field='penilai_wawancara_1'
                        handleSorting={handleSorting}
                        sorting={sorting}
                      />
                      <SortableHeaders
                        label='Penilai Wawancara 2'
                        field='penilai_wawancara_2'
                        handleSorting={handleSorting}
                        sorting={sorting}
                      />
                      <SortableHeaders
                        label='Penilai Wawancara 3'
                        field='penilai_wawancara_3'
                        handleSorting={handleSorting}
                        sorting={sorting}
                      />
                    </tr>
                  </thead>
                  <tbody>
                    {data?.data?.map((item: any, key: number) => (
                      <tr key={key}>
                        <td>{(pagination?.page - 1) * pagination?.per_page + key + 1}</td>
                        <td>
                          <span
                            onClick={() =>
                              window.open(
                                `/monitoring/administration/${item?.id_pendaftaran}`,
                                '_blank'
                              )
                            }
                            style={{cursor: 'pointer', color: 'blue', textAlign: 'right'}}
                          >
                            {item?.nama}
                          </span>
                        </td>
                        <td>{item?.no_registrasi}</td>
                        <td>{item?.kategori}</td>
                        <td>{item?.status_administrasi}</td>
                        <td>{timestampsFormat(item?.waktu_administrasi)}</td>
                        <td>{timestampsFormat(item?.waktu_proposal)}</td>
                        <td>
                          {item?.rata_rata_proposal && (
                            <span
                              onClick={() =>
                                window.open(
                                  `/monitoring/proposal/${item?.id_pendaftaran}`,
                                  '_blank'
                                )
                              }
                              style={{cursor: 'pointer', color: 'blue', textAlign: 'right'}}
                            >
                              {item?.rata_rata_proposal}
                            </span>
                          )}
                        </td>
                        <td>
                          {item?.rata_rata_wawancara && (
                            <span
                              onClick={() =>
                                window.open(
                                  `/monitoring/interview/${item?.id_pendaftaran}`,
                                  '_blank'
                                )
                              }
                              style={{cursor: 'pointer', color: 'blue', textAlign: 'right'}}
                            >
                              {item?.rata_rata_wawancara}
                            </span>
                          )}
                        </td>
                        <td>
                          <b>{item?.kode_verifikator}</b>-{item?.penilai_verifikator}
                        </td>
                        <td>
                          <b>{item?.kode_proposal_1}</b>-{item?.penilai_proposal_1}
                        </td>
                        <td>
                          <b>{item?.kode_proposal_2}</b>-{item?.penilai_proposal_2}
                        </td>
                        <td>
                          <b>{item?.kode_wawancara_1}</b>-{item?.penilai_wawancara_1}
                        </td>
                        <td>
                          <b>{item?.kode_wawancara_2}</b>-{item?.penilai_wawancara_2}
                        </td>
                        <td>
                          <b>{item?.kode_wawancara_3}</b>-{item?.penilai_wawancara_3}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>

            {/* Pagination */}
            <Row className='mt-3'>
              <Col md={6}>
                {data?.data?.length > 0 && !isLoading && (
                  <Dropdown>
                    <Dropdown.Toggle className='btn btn-sm'>{pagination.per_page}</Dropdown.Toggle>
                    <Dropdown.Menu>
                      {[10, 25, 50, 100].map((item) => (
                        <Dropdown.Item
                          key={item}
                          href='#'
                          onClick={() => onChangePerPage(item)}
                          disabled={pagination.per_page === item}
                        >
                          {item}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </Col>

              <Col md={6} className='text-end'>
                {!isLoading && (
                  <Pagination className='btn-sm'>
                    {paginator?.map((item: any) => (
                      <Pagination.Item
                        key={item}
                        active={item === pagination.page}
                        onClick={() => onChangePerPage(pagination.per_page, item)}
                        disabled={item === '...'}
                      >
                        {item}
                      </Pagination.Item>
                    ))}
                  </Pagination>
                )}
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

const PanaRegistrationPeriod = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Monitoring Super Admin
      </PageTitle>
      <PanaRegistrationPeriodPage />
    </>
  )
}

export default PanaRegistrationPeriod
